import R2 from "../../../../contents/docs/cdp/sources/_snippets/source-r2.mdx";
import * as React from 'react';
export default {
  R2,
  React
};